if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        // Vérifier si l'élément existe avant d'accéder à 'disabled'
        const idInput = this.form.querySelector("[name=id]");
        if (idInput) {
          idInput.disabled = false;
        } else {
          console.warn("ProductForm: Input with name 'id' not found.");
        }

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
        this.submitButton = this.querySelector('[type="submit"]'); // Définir submitButton ici pour accès plus tard
        this.spinner = this.querySelector(".button-overlay-spinner"); // Définir spinner ici
      }

      onSubmitHandler(event) {
        event.preventDefault();
        // Utiliser this.submitButton défini dans le constructeur
        if (!this.submitButton || this.submitButton.classList.contains("loading")) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (this.spinner) this.spinner.classList.remove("hidden"); // Utiliser this.spinner

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // Vérifier si minicart existe et a la fonction getSectionsToRender
        if (this.minicart && typeof this.minicart.getSectionsToRender === 'function') {
          formData.append(
            "sections",
            this.minicart.getSectionsToRender().map((section) => section.section),
          );
        } else {
          console.warn("ProductForm: Minicart or getSectionsToRender method not found. Skipping sections parameter.");
          // Vous pourriez ajouter des sections par défaut si nécessaire, ex: formData.append('sections', 'cart-drawer');
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        // --- Début du bloc fetch modifié ---
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            // Vérifier si la réponse est OK avant de tenter de parser le JSON
            if (!response.ok) {
                // Tenter de lire comme texte en cas d'erreur serveur non-JSON
                return response.text().then(text => {
                    throw { status: response.status, message: 'Server error', description: text };
                });
            }
            return response.json();
          })
          .then(async (response) => { // <<<=========== Ajout de async ici

            // Vérifier si response est un objet valide après le parsing JSON potentiel
            if (typeof response !== 'object' || response === null) {
                console.error("ProductForm: Invalid response received after add to cart.", response);
                this.handleErrorMessage("An unexpected error occurred."); // Message générique
                return; // Stopper si la réponse n'est pas exploitable
            }

            // Gestion de l'erreur d'ajout initial renvoyée par Shopify DANS le JSON
            if (response.status && response.status >= 400) { // Vérifier aussi >= 400
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description || response.message);
              // Mettre à jour même en cas d'erreur pour afficher les messages d'erreur du panier
              if (this.minicart && typeof this.minicart.updateSectionContents === 'function') {
                this.minicart.updateSectionContents();
              }
              return; // Arrêter ici si l'ajout initial a échoué
            }

            // --- Succès de l'ajout du produit principal ---
            console.log("Auto-Add Service: Main product added successfully (initial response):", response);

            // --- NOTRE LOGIQUE D'AJOUT DE SERVICE COMMENCE ICI ---
            const SERVICE_TAG = 'service';
            const SERVICE_50_TAG = 'service-50';
            const SERVICE_99_TAG = 'service-99';
            const SERVICE_50_VARIANT_ID = '55579325956478'; // Votre ID 50€
            const SERVICE_99_VARIANT_ID = '55579869741438'; // Votre ID 99€
            const ENGRAVING_TAG = 'gravage-obligatoire';
            const ENGRAVING_VARIANT_ID = '57627423113598';

            // La structure de 'response' peut varier, l'item ajouté est souvent directement la réponse
            // ou dans response.items[0] si Shopify change son API. Soyons prudents.
            const addedItem = Array.isArray(response?.items) ? response.items[0] : response;

            // Vérifier si addedItem est valide et a un variant_id
            if (!addedItem || typeof addedItem.variant_id === 'undefined') {
                 console.warn("Auto-Add Service: Could not reliably identify the added item from the response.", response);
            }
            // Éviter boucle infinie : ne pas ajouter de service si on vient d'ajouter un service
            else if (
                addedItem.variant_id == SERVICE_50_VARIANT_ID ||
                addedItem.variant_id == SERVICE_99_VARIANT_ID ||
                addedItem.variant_id == ENGRAVING_VARIANT_ID
            ) {
                console.log("Auto-Add Service: Service product added directly. Skipping auto-add logic.");
            }
            // Vérifier si on a le handle pour chercher les tags
            else if (addedItem.handle) {
                try {
                    console.log("Auto-Add Service: Fetching product data for handle:", addedItem.handle);
                    const productResponse = await fetch(`/products/${addedItem.handle}.js`); // Utiliser fetch standard

                    if (!productResponse.ok) {
                        console.error("Auto-Add Service: Failed to fetch product data. Status:", productResponse.status);
                        throw new Error('Failed to fetch product data');
                    }

                    const productData = await productResponse.json();

                    if (productData && productData.tags && Array.isArray(productData.tags)) {
                        const productTags = productData.tags;
                        console.log("Auto-Add Service: Tags found:", productTags);

                        if (productTags.includes(SERVICE_TAG)) {
                            let serviceVariantIdToAdd = null;
                            if (productTags.includes(SERVICE_50_TAG)) {
                                serviceVariantIdToAdd = SERVICE_50_VARIANT_ID;
                            } else if (productTags.includes(SERVICE_99_TAG)) {
                                serviceVariantIdToAdd = SERVICE_99_VARIANT_ID;
                            }

                            if (serviceVariantIdToAdd) {
                                console.log("Auto-Add Service: Service tag found. Need to add variant ID:", serviceVariantIdToAdd);

                                const cartCheckResponse = await fetch('/cart.js');
                                const currentCart = await cartCheckResponse.json();
                                const alreadyInCart = currentCart.items.some(item => item.variant_id == serviceVariantIdToAdd);

                                if (!alreadyInCart) {
                                    console.log("Auto-Add Service: Service not in cart. Adding...");
                                    const serviceAddConfig = {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                        body: JSON.stringify({
                                          items: [{ id: serviceVariantIdToAdd, quantity: 1 }],
                                          // Inclure les sections pour que la réponse contienne le HTML mis à jour
                                          sections: this.minicart && typeof this.minicart.getSectionsToRender === 'function' ? this.minicart.getSectionsToRender().map((section) => section.section).join(',') : null,
                                          sections_url: window.location.pathname
                                        })
                                    };
                                    // Nettoyer les sections si elles sont null
                                    if (!serviceAddConfig.body.sections) delete serviceAddConfig.body.sections;

                                    const serviceAddResponseFetch = await fetch(`${routes.cart_add_url}`, serviceAddConfig);
                                    const serviceAddResponse = await serviceAddResponseFetch.json(); // Lire la réponse JSON

                                    if (!serviceAddResponseFetch.ok) {
                                        console.error("Auto-Add Service: Failed to add service product.", serviceAddResponse);
                                    } else {
                                        console.log("Auto-Add Service: Service product added successfully.", serviceAddResponse);
                                        // Le mini-panier sera actualisé une seule fois après tous les ajouts.
                                    }
                                } else {
                                    console.log("Auto-Add Service: Service product already in cart.");
                                }
                            } else { /* ... pas de tag prix ... */ }
                        } else { /* ... pas de tag service ... */ }

                        const engravingSource = `${productData.type || ''} ${productTags.join(' ')}`
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .toLowerCase();
                        const requiresEngraving =
                            productTags.includes(ENGRAVING_TAG) ||
                            (engravingSource.includes('velo') && !engravingSource.includes('trottinette'));

                        if (requiresEngraving) {
                            const engravingQuantity = Math.max(1, Number.parseInt(addedItem.quantity, 10) || 1);
                            const engravingPayload = {
                                items: [{
                                    id: ENGRAVING_VARIANT_ID,
                                    quantity: engravingQuantity,
                                    properties: { '_gravage_obligatoire': 'true' }
                                }],
                                sections_url: window.location.pathname
                            };

                            if (this.minicart && typeof this.minicart.getSectionsToRender === 'function') {
                                engravingPayload.sections = this.minicart
                                    .getSectionsToRender()
                                    .map((section) => section.section)
                                    .join(',');
                            }

                            const engravingAddResponse = await fetch(`${routes.cart_add_url}`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                body: JSON.stringify(engravingPayload)
                            });
                            const engravingAddResult = await engravingAddResponse.json();

                            if (!engravingAddResponse.ok) {
                                console.error("Auto-Add Engraving: Failed to add engraving.", engravingAddResult);
                            }
                        }
                    } else { /* ... tags manquants ou invalides ... */ }
                } catch (error) {
                    console.error("Auto-Add Service: Error during auto-add service check/add:", error);
                }
            } else { /* ... handle manquant ... */ }
            // --- FIN DE NOTRE LOGIQUE D'AJOUT DE SERVICE ---


            // Dispatch de l'événement original (important pour d'autres scripts potentiels)
            // Assurer que 'response' est bien l'item principal ajouté
            const mainAddedItemForEvent = Array.isArray(response?.items) ? response.items[0] : response;
            if (mainAddedItemForEvent && typeof mainAddedItemForEvent.variant_id !== 'undefined') {
                const event = new CustomEvent("cart:item-add", {
                  detail: {
                    items: [mainAddedItemForEvent], // Envoyer seulement l'item principal
                    context: this.eventContext,
                  },
                });
                document.dispatchEvent(event);

                // Appel PubSub original
                publish(PUB_SUB_EVENTS.cartItemAdd, {
                  source: this.eventContext,
                  items: [mainAddedItemForEvent],
                });
            }

            // Rafraîchir une seule fois avec l'état final : vélo + prémontage + gravage.
            if (this.minicart && typeof this.minicart.updateSectionContents === 'function') {
              await this.minicart.updateSectionContents();
            }

            if (window.themeSettings.redirectToCart) {
              location.href = window.routes.cart_url;
            } else if (this.minicart && typeof this.minicart.open === 'function') {
              this.minicart.open(this.submitButton);
            }

          })
          .catch((e) => { // Gestion des erreurs réseau ou JSON parsing initiales
            console.error("ProductForm Submit Error:", e);
            // Essayer d'afficher un message même si l'erreur est technique
            this.handleErrorMessage(e?.description || e?.message || "An error occurred.");
          })
          .finally(() => { // S'exécute après succès ou erreur
            if (this.submitButton) {
                this.submitButton.classList.remove("loading");
                this.submitButton.removeAttribute("aria-disabled");
                // Note: La ligne 'if (this.cart)' semblait suspecte, retirée.
                // this.submitButton.removeAttribute("disabled"); // aria-disabled devrait suffire
            }
            if (this.spinner) this.spinner.classList.add("hidden");
          });
        // --- Fin du bloc fetch modifié ---
      } // Fin onSubmitHandler

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }
        // Initialiser les éléments si pas déjà fait (plus sûr)
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        if (!this.errorMessageWrapper) return; // Sortir si le wrapper n'existe pas
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form-error-message");
        if (!this.errorMessage) return; // Sortir si le message n'existe pas

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      } // Fin handleErrorMessage
    }, // Fin de la classe ProductForm
  ); // Fin customElements.define
} // Fin if
